<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              Mass Outages
            </h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                Click here to sync all down monitors with better uptime:
                <button v-if="user.userType === 'admin' || user.userType === 'super-admin'" :disabled="syncMassOutagesLoader" @click="syncMassOutages()" class="btn btn-primary pull-right btn-sm mr-3" >
                  <span>Monitors SYNC (Mass Outages)</span>
                </button>
              </div>
            </div>
            <div class="row mt-3" v-if="user.userType === 'admin' || user.userType === 'super-admin'">
              <div class="col-md-12">
                <div class="mb-2">
                  1- Forcefully resolve all monitors:
                  <small class="text-muted d-block">
                    Resolve all current down monitors in WPO only (no Zabbix API calls).
                  </small>
                  <button
                    :disabled="forceResolveLoader"
                    @click="forcefullyResolveAllMonitors"
                    class="btn btn-danger btn-sm ml-2"
                  >
                    <span v-if="!forceResolveLoader">Forcefully resolve all monitors</span>
                    <span v-else><i class="fa fa-spinner fa-spin mr-1"></i> Processing...</span>
                  </button>
                </div>
                <div class="mb-2">
                  2- Gracefully resolve all monitors:
                  <small class="text-muted d-block">
                    Pause all down monitors and then reactivate them, including Zabbix API calls.
                  </small>
                  <button
                    :disabled="graceResolveLoader"
                    @click="gracefullyResolveAllMonitors"
                    class="btn btn-success btn-sm ml-2"
                  >
                    <span v-if="!graceResolveLoader">Gracefully resolve all monitors</span>
                    <span v-else><i class="fa fa-spinner fa-spin mr-1"></i> Processing...</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import {db} from "@/firebase/init";

export default {
  name: "MassOutages",
  data () {
    return {
      syncMassOutagesLoader: false,
      forceResolveLoader: false,
      graceResolveLoader: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    syncMassOutages(){
      this.syncMassOutagesLoader = true;
      this.$http.post('/monitor/sync-mass-outages', {grant_type: 'token'}).then(resp => {
        swal('Synchronized!', resp.data.msg, 'success');
        this.addLog({
          message: 'Successfully synchronized monitors (Mass Outages)!',
          level: "info"
        })
      }).catch(e => {
        console.error(e);
        swal('Error!', 'Something went wrong while synchronizing monitors!', 'error');
      }).finally(() => {
        this.syncMassOutagesLoader = false;
      })
    },
    async forcefullyResolveAllMonitors () {
      try {
        this.forceResolveLoader = true;
        const ref = await db.collection('zabbixMonitors').where('status', '==', 'down').get();

        if (ref.size) {
          for (const [i, row] of ref.docs.entries()) {
            const data = row.data();
            await db.collection('zabbixMonitors').doc(row.id).update({
              status: 'up',
              statusCake: 'Active'
            });
          }
        }

        swal('Done!', 'All current down monitors have been resolved.', 'success');
        this.addLog({
          message: 'Forcefully resolved all monitors (Mass Outages)',
          level: 'warning'
        });
      } catch (e) {
        console.error(e);
        swal('Error!', 'Something went wrong while forcefully resolving monitors!', 'error');
      } finally {
        this.forceResolveLoader = false;
      }
    },
    async gracefullyResolveAllMonitors () {
      try {
        this.graceResolveLoader = true;
        const response = await this.$http.post('zabbix/gracefully-resolve-monitors', {
          grant_type: 'token',
        });
        swal('Done!',  'All monitors have been gracefully resolved.', 'success');
        this.addLog({
          message: 'Gracefully resolved all monitors (Mass Outages)',
          level: 'info'
        });
      } catch (e) {
        console.error(e);
        swal('Error!', 'Something went wrong while gracefully resolving monitors!', 'error');
      } finally {
        this.graceResolveLoader = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
